if (!customElements.get('paintpopo-footer')) {
  customElements.define('paintpopo-footer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', (event) => {
        const field = event.target;
        if (field instanceof HTMLSelectElement && field.closest('.pp-footer__localization')) {
          field.form?.requestSubmit();
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
